import * as Yup from 'yup';
import agentsFormModel from './agentsFormModel';

const {
    formField: {
        name,
        description,
        service_id,
        systemPrompt,
        temperature,
        topP,
        maxTokens,
        enableTools,
        enableMemory,
        enableReasoning,
        enableFunctionCall,
        enableSearch,
        enableCodeExecution,
        executionMode
    }
} = agentsFormModel;

export default [
    Yup.object().shape({
        [name.name]: Yup.string().required(name.requiredErrorMsg).max(255, 'Máximo 255 caracteres'),
        [description.name]: Yup.string().optional(),
        [service_id.name]: Yup.object().shape({
            value: Yup.string().required(),
            label: Yup.string().required()
        }).default(undefined).required(service_id.requiredErrorMsg),
        [systemPrompt.name]: Yup.string().required(systemPrompt.requiredErrorMsg),
        [temperature.name]: Yup.number().typeError('Debe ser un número').min(0, 'Mínimo 0').max(2, 'Máximo 2').optional().nullable(),
        [topP.name]: Yup.number().typeError('Debe ser un número').min(0, 'Mínimo 0').max(1, 'Máximo 1').optional().nullable(),
        [maxTokens.name]: Yup.number().typeError('Debe ser un número').min(1, 'Mínimo 1').optional().nullable(),
        [enableTools.name]: Yup.boolean().optional(),
        [enableMemory.name]: Yup.boolean().optional(),
        [enableReasoning.name]: Yup.boolean().optional(),
        [enableFunctionCall.name]: Yup.boolean().optional(),
        [enableSearch.name]: Yup.boolean().optional(),
        [enableCodeExecution.name]: Yup.boolean().optional(),
        [executionMode.name]: Yup.mixed().optional().nullable()
    })
];
